// costants
import { TABS } from "../../constants/index";
import { useTranslation } from "react-i18next";

export interface MenuItemType {
  id: number;
  key: string;
  icon: string;
  link: string;
  tooltipTitle: string;
  className?: string;
  tabId:
    | TABS.BOOKMARK
    | TABS.CALLS
    | TABS.CUSTOMERS
    | TABS.CONTACTS
    | TABS.SETTINGS
    | TABS.USERS;
}
const MENU_ITEMS: MenuItemType[] = [
  {
    id: 2,
    key: "pills-customers-tab",
    icon: "bx bxs-user-detail",
    tooltipTitle: "Clients",
    tabId: TABS.CUSTOMERS,
    link: "/customers",
  },
  {
    id: 3,
    key: "pills-contacts-tab",
    icon: "bx bx-server",
    tooltipTitle: "Products",
    tabId: TABS.CONTACTS,
    link: "/services",
  },
  {
    id: 4,
    key: "pills-calls-tab",
    icon: "bx bxs-comment",
    tooltipTitle: "Templates",
    tabId: TABS.CALLS,
    link: "/templates",
  },
  {
    id: 5,
    key: "pills-bookmark-tab",
    icon: "bx bx-dollar",
    tooltipTitle: "E-Invoice",
    tabId: TABS.BOOKMARK,
    link: "/invoices",
  },
  {
    id: 6,
    key: "profile",
    icon: "bx bx-user-circle",
    tooltipTitle: "Profile",
    tabId: TABS.BOOKMARK,
    link: "/profile",
  },
];

export { MENU_ITEMS };
